import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import { AuthContext } from "../../contexts/auth";
import { useNavigate, useParams } from "react-router-dom";

import { permite_acesso, PegarDados1 } from "../../services/api";

import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

import { set, useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import Detalhe_lancamento from "../Modulos/detalhe_lancamento_unidade";
import Detalhe_lancamento_BS from "../Modulos/detalhe_lancamento_unidade-bootstrap";
import Total_ciclo_segmento from "../Modulos/total_medio_ciclo";
import Media_ciclo_disciplina from "../Modulos/media_ciclo_disciplina";
import Media_disciplina_serie from "../Modulos/media_comparativa_serie_dis";
import Qtd_alunos_rec2 from "../Modulos/qtd_alunos_rec2";
import Percent_Lanc_Unidade_Serie from "../Modulos/percent_lancamento_unidade_serie";
import Percent_Lanc_Unidade_Serie_Prazo from "../Modulos/percent_lanc_Unidade_serie_prazo";
import DesempenhoPorSerie from "../Modulos/Qtd_alunos_serie_desempenho_unidade";

import Checkbox from "../Components/checkbox";

// import { Row, Form, Button, Container, Tab, Tabs, Table, Col } from "react-bootstrap";

import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Table from "react-bootstrap/Table";
import Col from "react-bootstrap/esm/Col";
import { keyboard } from "@testing-library/user-event/dist/keyboard";
import Accordion from 'react-bootstrap/Accordion';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import InputGroup from 'react-bootstrap/InputGroup';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Nav from 'react-bootstrap/Nav';
import Collapse from 'react-bootstrap/Collapse';

import Carrocel from '../Components/carrocel';

import { ConverteSerie } from "../Modulos/modulo";

import './index.css';

const schema = yup.object({}).required();

const Unidade = () => {

    let { cod_unidade } = useParams();

    const perfil = JSON.parse(localStorage.getItem("perfil"));


    console.log("cod_unidade", cod_unidade);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', '', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes']

    const avaliacaoOptions = ['AS1', 'AQ1', 'AP1', 'AV1', 'AS2', 'AQ2', 'AP2', 'AV2', 'AS3', 'AQ3', 'AP3', 'AV3', 'AS4', 'AQ4', 'AP4', 'AV4'];

    const serieOptions = [
        { value: '1-1', label: '1º Fund I' },
        { value: '1-2', label: '2º Fund I' },
        { value: '1-3', label: '3º Fund I' },
        { value: '1-4', label: '4º Fund I' },
        { value: '1-5', label: '5º Fund I' },
        { value: '1-6', label: '6º Fund II' },
        { value: '1-7', label: '7º Fund II' },
        { value: '1-8', label: '8º Fund II' },
        { value: '1-9', label: '9º Fund II' },
        { value: '2-1', label: '1ª Médio' },
        { value: '2-2', label: '2ª Médio' },
        { value: '2-3', label: '3ª Médio' },
    ];

    const usuario = JSON.parse(localStorage.getItem("user"));
    const token = localStorage.getItem("token");

    // CONTROLE(FUNCIONARIO,TOKEN,COD_UNI)

    const { authenticated, logout } = useContext(AuthContext);
    const navigate = useNavigate();
    const [acesso, setAcesso] = useState(false);
    const [avaliacao, setAvaliacao] = useState("AV3");
    const [serie, setSerie] = useState('1-1');

    const [dataInicio, setDataInicio] = useState('2023-09-04'); // Formato ISO (YYYY-MM-DD) 
    // const [dataFim, setDataFim] = useState(new Date().toISOString().split('T')[0]);
    // const [dataFim, setDataFim] = useState('2024-03-31');
    const amanha = new Date();
    amanha.setDate(amanha.getDate() + 1);
    const novaDataFim = amanha.toISOString().split('T')[0];
    const hoje = new Date();
    const diadehoje = hoje.toISOString().split('T')[0];

    const [dataFim, setDataFim] = useState(diadehoje);

    function formatarData(dataOriginal) {
        // Divide a string da data em ano, mês e dia
        const partes = dataOriginal.split('-');
        // Verifica se a string está no formato correto (ANO-MES-DIA)
        if (partes.length !== 3) {
            return 'Formato de data inválido';
        }
        // Reorganiza as partes da data no formato DIA-MES-ANO
        const dataFormatada = `${partes[2]}-${partes[1]}-${partes[0]}`;
        return dataFormatada;
    }


    console.log("Antes", dataInicio);

    // const [startDate, setStartDate] = useState('2022-09-01');
    // const [endDate, setEndDate] = useState(getCurrentDate());

    const handleAvaliacaoChange = (event) => {
        setAvaliacao(event.target.value);
    };


    const {
        register,
        setValue,
        handleSubmit,
        setFocus,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });



    useEffect(() => {
        (async () => {
            const resultado2 = await permite_acesso(usuario[0].email, token, "Unidade " + cod_unidade);
            setAcesso(resultado2);
        })();
    }, [avaliacao]);

    console.log("Acesso:", acesso);

    console.log("Depois", dataInicio);



    if (!acesso) {

        return (
            <div className="AcessoNegado">
                -- ACESSO NEGADO !!! --

                <a href="/login"> Voltar ao Login</a>

            </div>
        )
    }

    const handleData = (e) => {
        e.preventDefault();
        let dti = document.querySelector(
            "input[name = inicio]"
        ).value;
        console.log(dti);
        setDataInicio(dti);
        let dtf = document.querySelector(
            "input[name = fim]"
        ).value;
        console.log(dtf);
        setDataFim(dtf);

    };

    const Experiment = (Nperfil) => {
        if (Nperfil === "GESTOR")
            return (
                <>
                    <NavDropdown.Item href="/unidade/10">Barra da Tijuca</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/01">Bento Ribeiro</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/11">Campo Grande</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/04">Cascadura</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/16">Freguesia</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/15">Ilha do Governador</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/02">Madureira</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/13">Mangueira</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/14">Maricá</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/06">Nilópolis</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/17">Recreio</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/03">Santa Cruz</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/09">Seropédica</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/05">Taquara</NavDropdown.Item>

                </>
            );
        if (Nperfil.startsWith("DIRETOR")) {
            var numerosString = Nperfil.replace("DIRETOR", "").trim();
            var numerosArray = numerosString.split("-");
            var codigoDinamico = numerosArray.map(function (cod_unidade) {
                return (
                    <NavDropdown.Item href={`/unidade/${cod_unidade}`}>
                        {unidades[parseInt(cod_unidade)]}
                    </NavDropdown.Item>
                );
            });
            codigoDinamico.push(<NavDropdown.Item key="tesouraria" href="/tesouraria"> Tesouraria - Pagamentos </NavDropdown.Item>);
            return (codigoDinamico)
        };
        if (Nperfil.startsWith("SUPERVISOR")) {
            var numerosString = Nperfil.replace("SUPERVISOR", "").trim();
            var numerosArray = numerosString.split("-");
            var codigoDinamico = numerosArray.map(function (cod_unidade) {
                return (
                    <NavDropdown.Item href={`/unidade/${cod_unidade}`}>
                        {unidades[parseInt(cod_unidade)]}
                    </NavDropdown.Item>
                );
            });

            return (codigoDinamico)
        };
    }
    return (

        <div className="Homepage">
            <div className="sticky-top painel">

                <Navbar expand="lg" className="bg-body-tertiary">

                    <Navbar.Brand href="/">
                        <img
                            src="/novo-logo.png"
                            alt="Santa Mônica Rede de Ensino"
                            style={{ width: "40px", height: "40px", marginRight: "10px" }}
                        />
                        <span style={{ color: "#006cb5", fontFamily: "inherit", fontWeight: "bold" }}>Santa Mônica Rede de Ensino</span>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <NavDropdown
                                title="UNIDADES"
                            >
                                {Experiment(perfil[0].perfil)}
                            </NavDropdown>
                            <Nav.Link href={`/boletimplus/${cod_unidade}`}>BOLETIM PLUS</Nav.Link>
                            <Nav.Link href={`/ranking`}>RANKING DE ALUNOS</Nav.Link>
                            {/* <Nav.Link href={`/ranking-series`} active>RANKING DE SÉRIES</Nav.Link> */}
                            <NavDropdown title={`AVALIAÇÃO : ${avaliacao}`}>
                                {avaliacaoOptions.map(option => (
                                    <NavDropdown.Item
                                        key={option}
                                        onClick={() => setAvaliacao(option)}
                                    >
                                        {option}
                                    </NavDropdown.Item>
                                ))}
                            </NavDropdown>
                            <NavDropdown title={`SÉRIE : ${ConverteSerie(serie)}`}>
                                {serieOptions.map(option => (
                                    <NavDropdown.Item
                                        key={option.value}
                                        onClick={() => setSerie(option.value)}
                                    >
                                        {option.label}
                                    </NavDropdown.Item>
                                ))}
                            </NavDropdown>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>

            </div>
            <center>
                <h3 style={{ color: "#006cb5", fontFamily: "inherit", fontWeight: "bold" }}>
                    MONITORAMENTO DE NOTAS LANÇADAS
                </h3>
                <h4 style={{ color: "#006cb5", fontFamily: "inherit", fontWeight: "bold" }}>
                    <b> {unidades[parseInt(cod_unidade)]} </b>
                </h4>
            </center>
            <div className="lancamento">
                <Row>
                    <Col lg={12} sm={12}>
                        <center>
                            <Percent_Lanc_Unidade_Serie un={cod_unidade} av={avaliacao} se={serie} />
                        </center>

                    </Col>

                </Row>
                {avaliacao.startsWith("AS") ? null : (
                    <Row>
                        <Col lg={12} sm={12}>
                            <center>
                                <Percent_Lanc_Unidade_Serie_Prazo un={cod_unidade} av={avaliacao} se={serie} />
                            </center>

                        </Col>

                    </Row>
                )}
                <br />
                <Row>
                    <Col lg={12} sm={12}>
                        <center>
                            <DesempenhoPorSerie un={cod_unidade} />
                        </center>
                    </Col>
                </Row>
                <Row>
                    <Col lg={7} sm={12}>
                        <center>
                            <Detalhe_lancamento_BS un={cod_unidade} av={avaliacao} se={serie} />
                        </center>
                    </Col>
                    {/* <Col lg={5} sm={12}>
                        <center>
                            <Media_disciplina_serie un={cod_unidade} av={avaliacao} se={serie} />
                        </center>

                    </Col> */}
                    <Col lg={5} sm={12}>
                        <center>
                            <Qtd_alunos_rec2 un={cod_unidade} />
                        </center>
                    </Col>
                </Row>
                <br />
                <br />
                <Row>
                    {/* <Col lg={4} sm={12}>
                        <center>
                            <Total_ciclo_segmento un={cod_unidade} />
                        </center>

                    </Col>
                    <Col lg={4} sm={12}>
                        <center>
                            <Media_ciclo_disciplina un={cod_unidade} />
                        </center>
                    </Col> */}
                    {/* <Col lg={4} sm={12}>
                        <center>
                            <Qtd_alunos_rec2 un={cod_unidade} />
                        </center>
                    </Col> */}
                </Row>

            </div>

        </div>

    );
};

export default Unidade;